import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";  // 👈 import your file
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />   {/* 👈 render your onboarding app */}
  </React.StrictMode>
);

reportWebVitals();
